import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { CSSTransition } from 'react-transition-group';
import { IconButton } from '~/components';
import styles from './Book.module.scss';
import './static.css';
import { useLocation, useNavigate } from 'react-router-dom';
import quizApi from '~/api/quizApi';
import { toast } from 'react-toastify';
import { BarLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';
import { getGPLXCode } from '~/utils/600bca';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};
function Book() {
    const { t } = useTranslation();
    const [first, setFirst] = useState(true);
    const query = useQuery();
    const id = '600bca'; //query.get('id');

    useEffect(() => {
        const lessonTemp = localStorage.getItem('lesson');
        if (!lessonTemp) {
            localStorage.setItem('lesson', 'random');
            localStorage.setItem('exercise', 'test');
        }
    }, []);

    const lesson = localStorage.getItem('lesson') || query.get('lesson') || 'random';
    const exerciseParam = localStorage.getItem('exercise') || query.get('exercise') || 'test';
    const [gplxCode, setGPLXCode] = useState(getGPLXCode());

    const [current, setCurrent] = useState(1);
    const [book, setBook] = useState(null);

    useEffect(() => {
        if (lesson) setCurrent(lesson);
    }, [lesson]);

    const navigate = useNavigate();

    function handleOnClickGPLXCode(ele, code) {
        console.log('code', code);
        localStorage.setItem('gplxCode', code);
        setGPLXCode(code);
        window.location.reload()
    }


    function handleOnClickLesson(lessonId) {
        // console.log('lessonId', lessonId);
        setCurrent((prevCurrent) => {
            if (prevCurrent === lessonId) return 0;
            return lessonId;
        });
    }

    function handleOnClickEnterExercise(e, lessonId, exerciseId) {
        localStorage.setItem('exercise', exerciseId);
        localStorage.setItem('lesson', lessonId);
        navigate(`/lesson?lesson=${lessonId}&id=${exerciseId}`);
    }

    // load dữ liệu
    useEffect(() => {
        // console.log('id', id);
        if (!id) return;
        quizApi
            .getBook({
                id: id,
            })
            .then((res) => {
                setFirst(false);
                console.log('res.data', res.data);
                if (res && res.data.code === '00') {
                    // toast.success('Load dữ liệu thành công');
                    setBook(res.data.data);
                    setTimeout(() => {
                        const ele = document.getElementById(lesson);
                        // console.log('ele', ele)
                        if (ele)
                            ele.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center',
                            });
                    }, 0);
                } else {
                    toast.error(JSON.stringify(res.data));
                }
            })
            .catch((error) => {
                console.log(error);
                setFirst(false);
            });
    }, [id, lesson]);

    return first ? (
        <div id="loading">
            <BarLoader color="green" />
        </div>
    ) : !book ? (
        <div>No Data</div>
    ) : (
        <main className={styles.wrapper}>
            <div className={styles.content}>
                <div className={styles.header}>{book.name}</div>
                <div className={styles.gplxCode}>
                    <div className={clsx(styles.title)}>Chọn hạng GPLX muốn học:</div>
                    <div className={clsx(styles.box, gplxCode === "A1_A" && styles.active)}
                        onClick={(e) =>
                            handleOnClickGPLXCode(e, "A1_A")
                        }>A1, A</div>
                    <div className={clsx(styles.box, gplxCode === "B1" && styles.active)}
                        onClick={(e) =>
                            handleOnClickGPLXCode(e, "B1")
                        }>B1</div>
                    <div className={clsx(styles.box, gplxCode === "B" && styles.active)}
                        onClick={(e) =>
                            handleOnClickGPLXCode(e, "B")
                        }>B</div>
                    <div className={clsx(styles.box, gplxCode === "C1" && styles.active)}
                        onClick={(e) =>
                            handleOnClickGPLXCode(e, "C1")
                        }>C1</div>
                    <div className={clsx(styles.box, gplxCode === "C" && styles.active)}
                        onClick={(e) =>
                            handleOnClickGPLXCode(e, "C")
                        }>C</div>
                    <div className={clsx(styles.box, gplxCode === "D1_D2_D_BE_C1E_CE_D1E_D2E_DE" && styles.active)}
                        onClick={(e) =>
                            handleOnClickGPLXCode(e, "D1_D2_D_BE_C1E_CE_D1E_D2E_DE")
                        }>D1, D2, D, BE, C1E, CE, D1E, D2E, DE</div>
                </div>
                <div className={clsx(styles.scrollable)}>
                    {book.lessons.map((lesson, index) => {
                        if (!lesson.exercises || lesson.exercises.length === 0)
                            return '';
                        return (
                            <div key={`lesson_${lesson.id}`} id={lesson.id}>
                                {lesson.id === 'chapter1' && <div className={styles.heading1}>Học theo thứ tự</div>}
                                {lesson.id === 'random' && <div className={styles.heading1}>Luyện tập và thi thử</div>}
                                <div className={styles.lesson}>
                                    <div
                                        onClick={(e) =>
                                            handleOnClickLesson(lesson.id)
                                        }
                                        className={clsx(styles.tittle)}
                                    >
                                        {index + 1 + '. ' + lesson.tittle}
                                    </div>
                                    {/* <IconButton
                                        onClick={(e) =>
                                            handleOnClickEnterLesson(
                                                e,
                                                lesson.id,
                                            )
                                        }
                                        className={clsx(styles.icon)}
                                    >
                                        <i className="fa-solid fa-arrow-right-long"></i>{' '}
                                    </IconButton> */}
                                </div>

                                <CSSTransition
                                    in={current === lesson.id}
                                    timeout={300}
                                    classNames="fade"
                                    unmountOnExit
                                >
                                    <div className={styles.exercises}>
                                        {current === lesson.id &&
                                            lesson.exercises?.length > 0 &&
                                            lesson.exercises.map(
                                                (exercise, idx) => {
                                                    return (
                                                        <div
                                                            onClick={(e) =>
                                                                handleOnClickEnterExercise(
                                                                    e,
                                                                    lesson.id,
                                                                    exercise.id,
                                                                )
                                                            }
                                                            className={
                                                                clsx(styles.exercise, exerciseParam === exercise.id && styles.active)
                                                            }
                                                            key={`lesson_${lesson.id}_${exercise.id}`}
                                                        >
                                                            {exercise.type ===
                                                                'blank' && (
                                                                    <i
                                                                        className={clsx(
                                                                            styles.icon,
                                                                            'fa-solid fa-grip-lines',
                                                                        )}
                                                                    ></i>
                                                                )}
                                                            {exercise.type ===
                                                                'matching' && (
                                                                    <i
                                                                        className={clsx(
                                                                            styles.icon,
                                                                            'fa-solid fa-link',
                                                                        )}
                                                                    ></i>
                                                                )}
                                                            {exercise.type ===
                                                                'vocabulary-translate' && (
                                                                    <i
                                                                        className={clsx(
                                                                            styles.icon,
                                                                            'fa-solid fa-w',
                                                                        )}
                                                                    ></i>
                                                                )}
                                                            {exercise.type ===
                                                                'arrange' && (
                                                                    <i
                                                                        className={clsx(
                                                                            styles.icon,
                                                                            'fa-solid fa-arrow-down-short-wide',
                                                                        )}
                                                                    ></i>
                                                                )}
                                                            {exercise.type ===
                                                                'multiple-choices' && (
                                                                    <i
                                                                        className={clsx(
                                                                            styles.icon,
                                                                            'fa-regular fa-circle-check',
                                                                        )}
                                                                    ></i>
                                                                )}
                                                            {exercise.type ===
                                                                'translate' && (
                                                                    <i
                                                                        className={clsx(
                                                                            styles.icon,
                                                                            'fa-solid fa-language',
                                                                        )}
                                                                    ></i>
                                                                )}
                                                            {exercise.type ===
                                                                'blank-listening' && (
                                                                    <i
                                                                        className={clsx(
                                                                            styles.icon,
                                                                            'fa-solid fa-headphones-simple',
                                                                        )}
                                                                    ></i>
                                                                )}
                                                            {exercise.type ===
                                                                'arrange-listening' && (
                                                                    <i
                                                                        className={clsx(
                                                                            styles.icon,
                                                                            'fa-solid fa-headphones-simple',
                                                                        )}
                                                                    ></i>
                                                                )}
                                                            {exercise.type ===
                                                                'matching-listening' && (
                                                                    <i
                                                                        className={clsx(
                                                                            styles.icon,
                                                                            'fa-solid fa-headphones-simple',
                                                                        )}
                                                                    ></i>
                                                                )}
                                                            {exercise.type ===
                                                                'multiple-choices-listening' && (
                                                                    <i
                                                                        className={clsx(
                                                                            styles.icon,
                                                                            'fa-solid fa-headphones-simple',
                                                                        )}
                                                                    ></i>
                                                                )}
                                                            {exercise.type ===
                                                                'crossword' && (
                                                                    <i
                                                                        className={clsx(
                                                                            styles.icon,
                                                                            'fa-solid fa-route',
                                                                        )}
                                                                    ></i>
                                                                )}{' '}
                                                            {exercise.name}
                                                        </div>
                                                    );
                                                },
                                            )}
                                    </div>
                                </CSSTransition>
                            </div>
                        );
                    })}
                </div>
                <div className={styles.action}>
                    <div>{t('welcome')}</div>
                </div>
            </div>
        </main>
    );
}

export default Book;
